import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Grid
} from "@material-ui/core";
import { deviceCMSPlayerAPI } from "../../apis/deviceControlApi";
import { useTranslation } from "../../langs/useTranslation";
import useStyles from "../../styles/dialogStyle";
import { StyledSubmitBtn, BackBtn } from "../commons/FormBtns";

const CMSPlayer = props => {
  const classes = useStyles();
  const { t, langConf } = useTranslation("deviceControl");
  const [enabledType, setEnabledType] = useState("1");
  const [playEnabledType, setPlayEnabledType] = useState("1");
  const [loading, setLoading] = useState(false);
  const {
    open,
    setOpen,
    cmsEnabledType,
    cmsPlayEnabledType,
    selectType,
    selectDevices,
    selectDevice,
    numType,
    groupId,
    tagId,
    selectCompany,
    checkAll
  } = props;

  const onClose = () => {
    setOpen(false);
  };

  const onConfirm = async () => {
    try {
      setLoading(true);
      const successText = "dialog.successText";
      const res = await deviceCMSPlayerAPI(
        selectType,
        selectCompany,
        checkAll
          ? undefined
          : numType === "single"
          ? [selectDevice]
          : selectDevices,
        groupId,
        tagId,
        "cms_mode",
        enabledType,
        playEnabledType,
        t,
        successText
      );
      if (res) {
        setOpen(false);
      }
    } finally {
      setLoading(false);
    }
  };

  const selectTypeHandler = e => {
    setEnabledType(e.target.value);
  };

  const selectPlayTypeHandler = e => {
    setPlayEnabledType(e.target.value);
  };

  useEffect(() => {
    setEnabledType(cmsEnabledType);
  }, [cmsEnabledType]);

  useEffect(() => {
    setPlayEnabledType(cmsPlayEnabledType);
  }, [cmsPlayEnabledType]);

  return (
    <Dialog
      maxWidth="md"
      className={classes.dialog}
      onClose={onClose}
      open={open}
      aria-labelledby="add-event-dialog"
      aria-describedby="add-event-dialog"
    >
      <DialogTitle id="add-edit-alarm-notification">
        {t("common.cmsPlayer", {nubis: langConf.deviceCenter?.nubisText || "Nubis"})}
      </DialogTitle>
      <>
        <DialogContent>
          <div className={classes.deviceControlDialogOuter}>
            <div className="deviceControlDialogBlock">
              <div className="title">
                {t({ defaultMessage: "启动内容播放器" }, { nubis: langConf.deviceCenter?.nubisText || "Nubis" })}
              </div>
              <div
                className="selectdateArea"
                style={{ marginLeft: "30px", marginRight: "30px" }}
              >
                <FormControl component="div" fullWidth={true}>
                  <RadioGroup
                    aria-label="date"
                    value={enabledType}
                    onChange={selectTypeHandler}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl>
                          <FormControlLabel
                            value="1"
                            label={`${t({
                              defaultMessage: "开"
                            })}`}
                            control={<Radio color="primary" />}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl>
                          <FormControlLabel
                            value="0"
                            label={`${t({
                              defaultMessage: "关"
                            })}`}
                            control={<Radio color="primary" />}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </RadioGroup>
                  {enabledType === "1" && (
                    <>
                      <div
                        style={{ fontSize: 15, marginLeft: 28, marginTop: 8 }}
                      >
                        {t({ defaultMessage: "Player切换" }, {nubis: langConf.deviceCenter?.nubisText || "Nubis"})}
                      </div>
                      <RadioGroup
                        aria-label="date"
                        value={playEnabledType}
                        onChange={selectPlayTypeHandler}
                        style={{ marginLeft: 28, marginRight: 28 }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} md={6} lg={6}>
                            <FormControl>
                              <FormControlLabel
                                value="1"
                                label={`${t({
                                  defaultMessage: "开"
                                })}`}
                                control={<Radio color="primary" />}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={6}>
                            <FormControl>
                              <FormControlLabel
                                value="0"
                                label={`${t({
                                  defaultMessage: "关"
                                })}`}
                                control={<Radio color="primary" />}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </RadioGroup>
                    </>
                  )}
                </FormControl>
              </div>
            </div>
          </div>
        </DialogContent>

        <DialogActions className={classes.noMarginBtn}>
          <StyledSubmitBtn
            btnColor="primary"
            type="button"
            disabled={loading}
            btnText={t("dialog.confirmBtn")}
            onClick={onConfirm}
          />
          <BackBtn onClick={onClose} btnText={t("dialog.cancel")} />
        </DialogActions>
      </>
    </Dialog>
  );
};

export default CMSPlayer;
